class PredictiveSearch extends HTMLElement {
    constructor() {
      super();
  
      this.input = this.querySelector('input[type="search"]');
      this.predictiveSearchResults = this.querySelector('#predictive-search');
  
      this.input.addEventListener('input', this.debounce((event) => {
        this.onChange(event);
      }, 300).bind(this));
      this.reset();
    }
  

    // On /ar the suggest endpoint is /ar/search/suggest. Hardcoding the English
    // path returned English results to Arabic shoppers.
    static searchUrl() {
      if (window.routes && window.routes.predictive_search_url) return window.routes.predictive_search_url;
      const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      return root.replace(/\/+$/, '') + '/search/suggest';
    }

    onChange() {
      const searchTerm = this.input.value.trim();
  
      if (!searchTerm.length) {
        this.close();
        return;
      }
  
      this.getSearchResults(searchTerm);
    }
  
    getSearchResults(searchTerm) {
      fetch(
        `${PredictiveSearch.searchUrl()}?` +
          new URLSearchParams({
            q: searchTerm,
            'resources[type]': 'product',
            'resources[limit]': '10',
            'options[prefix]': 'last',
            section_id: 'predictive-search',
          })
      )
        .then((response) => {
          if (!response.ok) {
            // /ar/search/suggest answers 417 "Unsupported buyer locale", so Arabic
            // shoppers got an empty panel and an uncaught rejection per keystroke.
            // Offer the full results page rather than failing silently.
            this.showFallback(searchTerm);
            return null;
          }
  
          return response.text();
        })
        .then((text) => {
          if (text === null) return;
          const section = new DOMParser()
            .parseFromString(text, 'text/html')
            .querySelector('#shopify-section-predictive-search');
          if (!section) {
            this.showFallback(searchTerm);
            return;
          }
          this.predictiveSearchResults.innerHTML = section.innerHTML;
          this.open();
          this.productWishPreload();
        })
        .catch(() => {
          // network failure, offline, blocked request - same recovery
          this.showFallback(searchTerm);
        });
    }

    // Built with DOM APIs and textContent on purpose: the search term is user
    // input and must never reach innerHTML.
    showFallback(searchTerm) {
      const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      const template =
        (window.predictiveSearchStrings && window.predictiveSearchStrings.viewAllForTerm) ||
        'See all results for "__TERM__"';

      const wrap = document.createElement('div');
      wrap.className = 'WI_searchFallback';

      const link = document.createElement('a');
      link.className = 'WI_searchFallback_link';
      link.href = root.replace(/\/+$/, '') + '/search?q=' + encodeURIComponent(searchTerm);
      link.textContent = template.replace('__TERM__', searchTerm);

      wrap.appendChild(link);
      this.predictiveSearchResults.replaceChildren(wrap);
      this.open();
    }
  reset() {
    this.querySelector('.saerchClear')?.addEventListener('click', ()=>{
      this.input.value = "";
      this.onChange();
    })
  }
    open() {
      if (this.querySelector('.WI_searchUPsell')) this.querySelector('.WI_searchUPsell').style.display = 'none';
      if (this.querySelector('.WI_searchResult')) this.querySelector('.WI_searchResult').style.display = 'flex';
      if (this.querySelector('.saerchClear')) this.querySelector('.saerchClear').style.display = 'flex';
    }
  
    close() {
      if (this.querySelector('.WI_searchUPsell')) this.querySelector('.WI_searchUPsell').style.display = 'flex';
      if (this.querySelector('.WI_searchResult')) this.querySelector('.WI_searchResult').style.display = 'none';
      if (this.querySelector('.saerchClear')) this.querySelector('.saerchClear').style.display = 'none';
    }
  
    debounce(fn, wait) {
      let t;
      return (...args) => {
        clearTimeout(t);
        t = setTimeout(() => fn.apply(this, args), wait);
      };
    }
    // Preload all the product which is stored
    productWishPreload() {
      // Was a third copy of the same restore loop, looking elements up by id -
      // which only ever found the first of a duplicated one. Defers to the single
      // shared implementation in WI_wishList.js.
      if (typeof window.wiWishlistRestoreAll === 'function') window.wiWishlistRestoreAll();
    }
  }
  
  customElements.define('predictive-search', PredictiveSearch);
  